<template>
    <v-container fluid grid-list-md>
        <v-layout wrap>
            <v-flex xs12>
                <h3>Поиск</h3>
            </v-flex>
            <v-flex xs12>
                <v-card>
                    <v-container  fluid grid-list-md>
                        <v-layout>
                            <v-flex xs12 sm4>
                                <v-menu
                                        ref="menuFilter"
                                        v-model="menuFilter"
                                        :close-on-content-click="false"
                                        :return-value.sync="search.period_pay"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                                :value="computedDateFormattedMomentjs"
                                                label="Период оплаты"
                                                prepend-icon="mdi-calendar-month"
                                                readonly
                                                v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                            v-model="search.period_pay"
                                            type="month"
                                            no-title
                                            scrollable
                                            @input="savePeriod"
                                    >
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>

                            <!--<v-flex xs12 sm4>-->
                                <!--<v-menu-->
                                        <!--ref="menuFilter"-->
                                        <!--:close-on-content-click="false"-->
                                        <!--v-model="menuFilter"-->
                                        <!--:nudge-right="40"-->
                                        <!--lazy-->
                                        <!--transition="scale-transition"-->
                                        <!--offset-y-->
                                        <!--full-width-->
                                        <!--min-width="290px"-->
                                <!--&gt;-->
                                    <!--<v-text-field-->
                                            <!--slot="activator"-->
                                            <!--:value="computedDateFormattedMomentjs"-->
                                            <!--label="Период оплаты"-->
                                            <!--prepend-icon="event"-->
                                            <!--readonly-->
                                    <!--&gt;</v-text-field>-->
                                    <!--<v-date-picker-->
                                            <!--ref="picker"-->
                                            <!--v-model="search.period_pay"-->
                                            <!--@input="savePeriod"-->
                                            <!--reactive-->
                                            <!--no-title-->
                                            <!--locale="ru"-->
                                    <!--&gt;</v-date-picker>-->
                                <!--</v-menu>-->
                            <!--</v-flex>-->
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 sm6 md3>
                                <v-card-actions>
                                    <v-autocomplete
                                            v-model="search.boroughSubFed_id"
                                            v-on:change="search_federation_borough"
                                            :items="federation_borough"
                                            item-text="name"
                                            item-value="id"
                                            label="Район субъекта федерации"
                                            :loading="listLoading.includes('fetchFederationBorough')"
                                    >
                                    </v-autocomplete>
                                </v-card-actions>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-card-actions>
                                    <v-autocomplete
                                            v-model="search.super_town_id"
                                            v-on:change="search_super_towns"
                                            :items="super_towns"
                                            item-text="full_name"
                                            item-value="id"
                                            label="Административно вышестоящий город"
                                            :loading="listLoading.includes('fetchSuperTowns')"
                                    >
                                    </v-autocomplete>
                                </v-card-actions>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-card-actions>
                                    <v-autocomplete
                                            v-model="search.town_id"
                                            v-on:change="search_towns"
                                            :items="towns"
                                            item-text="full_name"
                                            item-value="id"
                                            label="Населенный пункт"
                                            :loading="listLoading.includes('fetchTowns')"
                                    >
                                    </v-autocomplete>
                                </v-card-actions>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-card-actions>
                                    <v-autocomplete
                                            v-model="search.street_id"
                                            v-on:change="search_towns"
                                            :items="streets"
                                            item-text="name"
                                            item-value="id"
                                            label="Улица"
                                            :loading="listLoading.includes('fetchStreets')"
                                    >
                                    </v-autocomplete>
                                </v-card-actions>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-card-actions>
                                    <v-text-field
                                            v-model="search.houseNumber"
                                            v-on:change="search_towns"
                                            label="Номер дома"
                                            :counter="10"
                                    >
                                    </v-text-field>
                                </v-card-actions>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-card-actions>
                                    <v-text-field
                                            v-model="search.building"
                                            v-on:change="search_towns"
                                            label="Корпус дома"
                                            :counter="10"
                                    >
                                    </v-text-field>
                                </v-card-actions>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-card-actions>
                                    <v-text-field
                                            v-model="search.flatNumber"
                                            v-on:change="search_towns"
                                            label="Номер квартиры"
                                            :counter="10"
                                    >
                                    </v-text-field>
                                </v-card-actions>
                            </v-flex>
                            <v-flex xs12>
                                <v-card-actions>

                                    <v-spacer></v-spacer>
                                    <v-btn
                                            icon
                                            class="mr-2 mt-4"
                                            @click="get_accounts()"
                                    >
                                        <v-icon large>mdi-magnify</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-flex>
                        </v-layout>
                    </v-container>

                </v-card>
            </v-flex>
            <v-flex>
                <v-data-table
                        :items="accounts.results"
                        :server-items-length="accounts.last_page"
                        :loading="listLoading.includes('fetchListFiles')"
                        hide-default-footer
                        v-model="accounts.results"
                        no-results-text="Нет отфильтрованных данных"
                        class="elevation-1">
                    <template v-slot:header>
                        <tr>
                            <th>Код</th>
                            <th>Лицевой счет</th>
                            <th>Адрес</th>
                            <th>
                            </th>
                        </tr>
                    </template>
                    <template v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td>{{ item.id }}</td>
                                <td>{{ item.account }}</td>
                                <td>{{ item.short_address }}</td>
                                <td class="justify-center layout mx-0">
                                    <v-btn
                                            icon
                                            class="mr-2"
                                            @click="editItem(item)"
                                    >
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>

                    </template>
                </v-data-table>
                <div class="text-xs-center pt-2">
                    <v-pagination
                            key="pagination"
                            v-model="pagination.page"
                            :length="accounts.last_page"
                    ></v-pagination>
                </div>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
import moment from 'moment'

export default {
  name: 'receipt',
  data () {
    return {
      menuFilter: false
    }
  },
  watch: {
    pagination: {
      handler () {
        this.get_accounts()
      },
      deep: true
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    subject_federation () {
      return this.$store.getters['esrn_common/subject_federation']
    },
    federation_borough () {
      return this.$store.getters['esrn_common/federation_borough']
    },
    super_towns () {
      return this.$store.getters['esrn_common/super_towns']
    },
    towns () {
      return this.$store.getters['esrn_common/towns']
    },
    borough () {
      return this.$store.getters['esrn_common/borough']
    },
    streets () {
      return this.$store.getters['esrn_common/streets']
    },
    accounts () {
      return this.$store.getters['gku_receipts/accounts']
    },
    computedDateFormattedMomentjs () {
      return this.search.period_pay ? moment(this.search.period_pay).format('MMMM YYYY') : ''
    },
    search () {
      return this.$store.getters['gku_receipts/search']
    },
    pagination () {
      return this.$store.getters['gku_receipts/pagination']
    }
  },
  methods: {
    search_federation_borough () {
      this.run_new_search()
      this.$store.dispatch('esrn_common/fetchSuperTowns',
        {
          'boroughSubFed_id': this.search.boroughSubFed_id
        })
        .then(() => {
          this.search.super_town_id = null
        })
      this.$store.dispatch('esrn_common/fetchTowns',
        {
          'boroughSubFed_id': this.search.boroughSubFed_id,
          'parent_id': this.search.super_town_id
        })
        .then(() => {
          this.search.town_id = null
        })
    },
    search_super_towns () {
      this.run_new_search()
      this.$store.dispatch('esrn_common/fetchTowns', {
        'boroughSubFed_id': this.search.boroughSubFed_id,
        'parent_id': this.search.super_town_id
      })
        .then(() => {
          this.search.town_id = null
        })
    },
    search_towns () {
      this.run_new_search()
      this.$store.dispatch('esrn_common/fetchStreets', { 'town_id': this.search.town_id })
    },
    run_new_search () {
      this.search.new_search = true
    },
    get_accounts () {
      this.$store.dispatch('gku_receipts/fetchAccounts', { 'search': this.search, 'pagination': this.pagination })
    },
    savePeriod (period) {
      this.$refs.menuFilter.save(period)
      // this.$refs.picker.activePicker = 'MONTH'
      this.menuFilter = true
    },
    editItem (item) {
      this.$router.push({
        name: 'gku_receipt',
        params: {
          'period_pay': this.search.period_pay,
          'account': item.account } })
    }
  }
}
</script>

<style scoped>

</style>
